import { render, staticRenderFns } from "./NoRowsOverlay.vue?vue&type=template&id=77146a8c&scoped=true&"
var script = {}
import style0 from "./NoRowsOverlay.vue?vue&type=style&index=0&id=77146a8c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77146a8c",
  null
  
)

export default component.exports